import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "../common/axios";
import { useRecoilState } from "recoil";
import { Timer } from "lucide-react";
import { Button } from "./ui/button";
import { userState } from "../common/atom/userState";

const SessionUpdateBtn = ({ fullWidth = false }) => {
  const [{ expiresIn, sessionUpdatedAt }, setUser] = useRecoilState(userState);
  const [remain, setRemain] = useState(null);
  useEffect(() => {
    if (expiresIn === null) return;
    setRemain(expiresIn);
  }, [sessionUpdatedAt, expiresIn]);

  useEffect(() => {
    const timer = setInterval(() => {
      setRemain((r) => {
        if (r == null) return r;
        return r > 0 ? r - 1 : 0;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []); // ⭐ 중요: 빈 배열

  const extendSession = async () => {
    Swal.fire({
      title: "세션 연장을 하시겠습니까?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "네",
      cancelButtonText: "아니오",
      didOpen: () => {
        const container = Swal.getContainer();
        if (container) {
          container.style.zIndex = "2000";
        }
      },
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        const res = await axios.post(
          "/session/refresh",
          {},
          { withCredentials: true },
        );

        if (res.data.ok) {
          setUser((prev) => ({
            ...prev,
            expiresIn: res.data.expiresIn, // ⭐ 다시 세팅
            sessionUpdatedAt: Date.now(),
          }));

          Swal.fire({
            title: "세션 연장",
            icon: "success",
            text: "세션이 연장되었습니다.",
            didOpen: () => {
              const container = Swal.getContainer();
              if (container) {
                container.style.zIndex = "2000";
              }
            },
          });
        }
      } catch (e) {
        Swal.fire({
          title: "세션 연장 실패",
          icon: "error",
          text: "다시 로그인하세요.",
          didOpen: () => {
            const container = Swal.getContainer();
            if (container) {
              container.style.zIndex = "2000";
            }
          },
        });
      }
    });
  };
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={extendSession}
      className={`inline-flex items-center gap-1 whitespace-nowrap shrink-0 ${fullWidth ? "w-full" : ""}`}
    >
      <Timer className="size-3.5 md:hidden" aria-hidden="true" />
      <span className="hidden md:inline">세션 만료까지 </span>
      <span className="sr-only md:hidden">세션 만료까지 </span>
      {Math.floor(remain / 60)}:{(remain % 60).toString().padStart(2, "0")}
    </Button>
  );
};

export default SessionUpdateBtn;
